import React, { useState, useEffect } from 'react';
import NavBar from './components/NavBar';
import { Route, Routes } from 'react-router-dom';
import HomePage from './components/HomePage';
import About from './components/About';
import Footer from './components/Footer';
import { Flex } from '@chakra-ui/react';
import { HashLoader } from 'react-spinners';
import ProjectsPage from './components/ProjectsPage';
import MainProjectsPage from './components/MainProjectsPage';
import ContactPage from './components/ContactPage';
import ProjectInfoPage from './pages/ProjectInfoPage';
import NotFound from './pages/NotFound';

function App() {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => {
      setLoading(false);
    }, 3500);


    return () => {
      clearTimeout(timer);
    };
  }, []);

  if (process.env.NODE_ENV === 'production')
    console.log = function no_console() {};

  return (
    <>
      {loading ? (
        <Flex
          w={'100vw'}
          h={'100vh'}
          justifyContent={'center'}
          alignItems={'center'}
        >
          <HashLoader size={'90px'} color="#2776b4" />
        </Flex>
      ) : (
        <Flex
          mx={'auto'}
          w={['80%', '80%', '80%', '80%', '60%', '60%']}
          minH={'100vh'}
          direction={'column'}
          justifyContent={'space-between'}
        >
          <NavBar></NavBar>
          <Routes>
            <Route path='*' element={<NotFound/>}/>
            <Route path="/" element={<HomePage loading={loading}/>} />
            <Route path="about" element={<About />} />
            <Route path="main_projects">
              <Route index element={<MainProjectsPage />} />
              <Route path=":projectId" element={<ProjectInfoPage/>} />
            </Route>
            <Route path='side_projects'>
            <Route index element={<ProjectsPage />}/>
            <Route path=":projectId" element={<ProjectInfoPage/>} />
            </Route>
            <Route path="contact" element={<ContactPage />} />
          </Routes>
          <Footer></Footer>
        </Flex>
      )}
    </>
  );
}

export default App;
